import ProfessionalAtWorkImage from './social-enterprise-partner.jpg';

export const ApproachSection = () => {
  return (
    <section className='py-16 pb-12 bg-white'>
      <div className='container mx-auto px-8 max-w-[1120px]'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-[72px] items-center'>
          <div>
            <p className='text-base font-bold uppercase tracking-widest text-brand-500 mb-3'>
              Our approach
            </p>
            <h2 className='text-display-md font-bold text-gray-700 tracking-tight mb-6'>
              Where leadership meets impact
            </h2>
            <p className='text-base leading-relaxed text-gray-500 mb-4'>
              MovingWorlds connects experienced professionals with social enterprises solving real
              problems around the world. You lead a hands-on project; they gain the support they
              need to grow.
            </p>
            <p className='text-base leading-relaxed text-gray-500 mb-4'>
              For over a decade, professionals have called this some of the most meaningful work
              of their careers. Now we&rsquo;re redesigning what comes next.
            </p>
            <p className='text-base leading-relaxed text-gray-500'>
              To scale this impact and better support the next generation of leaders, we&rsquo;re
              pausing to think through how this program can work best for professionals and
              organizations. We want to make sure our next phase genuinely serves your goals, so
              we&rsquo;d love to hear your thoughts.
            </p>
          </div>

          <figure className='m-0 relative rounded-2xl overflow-hidden border border-gray-100 shadow-lg aspect-[4/3.4] bg-gray-50'>
            <img
              src={ProfessionalAtWorkImage}
              alt='Social enterprise partner at work'
              className='w-full h-full object-cover'
              loading='lazy'
            />
          </figure>
        </div>
      </div>
    </section>
  );
};
